export const isAdmin = Boolean(
  process.env.NODE_ENV === 'development' ||
    process.env.REACT_APP_ENV === 'development' ||
    process.env.REACT_APP_ENV === 'uat',
);
